(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template-order"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    // 注文詳細のアコーディオン機能
    $('.order-toggle').on('click', function() {
      const $toggle = $(this);
      const targetId = $toggle.data('target');
      const $targetElement = $('#' + targetId);

      if ($targetElement.length) {
        const isActive = $toggle.hasClass('active');

        // クリックされたアイテムの状態を切り替え
        if (!isActive) {
          $toggle.addClass('active');
          $targetElement.slideDown(400);
        } else {
          $toggle.removeClass('active');
          $targetElement.slideUp(400);
        }
      }
    });
  });
  
  } catch(e) { console.error(e); }
})();
})();
